//@flow
import * as Immutable from 'immutable';

import { ShiftId } from 'common/models/flow/ShiftId';
import type { ShiftIdModelType } from 'common/models/flow/ShiftId';

//Validation stuff
import { validatable, validateAll } from 'common/utils/ValidationUtil';

@validatable
class InternalShiftId extends ShiftId {
    static fromJS(json: ShiftIdModelType): InternalShiftId {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }

    @validateAll
    setAllValidationErrors(): this {
        return this;
    }
}

export { InternalShiftId as ShiftId };
